module.exports = "/_next/static/images/Milwaukee-Ad-43e1dd5dd3cdc4b08e76ecd80ddf4193.jpg";